<template>
	<div>
		<div class="user-selector">
			<div class="user-selected" v-on:click="open = !open" :style="'background-color: ' + getStylistColor(assignedTo)">
				<template v-for="user in getUsers" v-if="user.id == assignedTo">
					{{ user.initials }}
				</template>
			</div>
			<div class="select-wrapper" v-if="open">
				<select :disabled="disabled" v-model="assignedTo" v-on:change="changed">
					<option value="">[ Nobody ]</option>
					<option :value="user.id" v-for="user in getUsers">{{ user.shortened_name }}</option>
				</select>
				<button class="small-margin-top smaller" v-on:click="me()">Assign to me</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'value',
    'disabled'
  ],
  data: () => ({
    open: false
  }),
  computed: {
    ...mapGetters([
      'getUsers',
      'getStylist'
    ]),
    assignedTo: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    me () {
      this.assignedTo = this.getStylist.id
      this.changed()
    },
    changed () {
      this.$emit('change')

      this.open = false
    },
    getStylistColor (id) {
      for (var i in this.getUsers) {
        if (id == this.getUsers[i].id) {
          return this.getUsers[i].color
        }
      }

      return '#fff'
    }
  }
}
</script>
